// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"91eafa6f","265":"62d68631","311":"1c48845f","787":"9089fad2"}[chunkId] + ".chunk.js";
};